import { TGR_BUTTION_LINK_ID } from "../../../../../common/constants";
import { triggerTracking } from "../../../../../utility/tracking";

export interface Input {
  site?: string;
  amount?: string;
  currency?: string;
  onCalculate?: (data: any) => Promise<void>;
}
export interface State {
  amount?: string;
}

export default class AppCalculateAction extends Marko.Component<Input, State> {
  inputElement: any;
  onCreate(input: Input) {
    this.state = { amount: this.convertToNumberFormat(input.amount) };
  }
  onMount() {
    this.inputElement = document.getElementById("input-zero")!;
    const calculateButtonElement = document.getElementById("trigger-btn")!;
    this.inputElement.setAttribute(
      "aria-label",
      `Total amount in ${this.input.site == "UK" ? "British Pound" : "U.S. Dollar"}`,
    );
    this.inputElement.focus();
    window.addEventListener("resize", () => {
      this.inputElement.focus();
    });
    this.inputElement.addEventListener("keydown", (e: any) => {
      if (e.code === "Enter") {
        triggerTracking(TGR_BUTTION_LINK_ID);
        calculateButtonElement.click();
      }
    });
  }
  calculatePayments() {
    const amount = this.state.amount?.replace(/,/g, "");
    this.emit("calculate", {
      site: this.input.site,
      currency: this.input.currency,
      amount,
    });
    this.state.amount = this.convertToNumberFormat(amount);
  }
  onDestory() {
    window.removeEventListener("resize", () => {});
    this.inputElement.removeEventListener("keydown", () => {});
  }

  updateAmount(event: any) {
    const tempState = JSON.parse(JSON.stringify(this.state.amount));
    this.state.amount = event.value;
    event.value = event.value.replace(/,/g, "");
    const regex = /^\d{1,5}(\.\d{0,2})?$/gm;
    if (event.value && !regex.test(event.value)) {
      this.state.amount = tempState;
      event.originalEvent.target.value = tempState;
    }
  }
  convertToNumberFormat(value: any) {
    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(value);
  }
}
